// Import necessary libraries
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home"; // Import your Home component
import AboutUs from "../pages/AboutUs";
import HowItWork from "../pages/HowItWork";
import ContactUs from "../pages/ContactUs";
import BookAppointment from "../pages/BookAppointment";
import UserPersonalInfo from "../UserProfile/UserPersonalInfo";
import UserChangePassword from "../UserProfile/UserChangePassword";
import UserMyMedicalReport from "../UserProfile/UserMyMedicalReport";
import UserMyOrder from "../UserProfile/UserMyOrder";
import UserMyOrderDetail from "../UserProfile/UserMyOrderDetail";
import UserMyConsultations from "../UserProfile/UserMyConsultations";
import UserPastConsultations from "../UserProfile/UserPastConsultations";
import UserCurrentConsultations from "../UserProfile/UserCurrentConsultations";
import UserConsultationDetail from "../UserProfile/UserConsultationDetail";
import UserPastConsultationsDetail from "../UserProfile/UserPastConsultationsDetail";
import UserCurrentConsultationsDetail from "../UserProfile/UserCurrentConsultationsDetail";
import UserChat from "../UserProfile/UserChat";
import UserPrescription from "../UserProfile/UserPrescription";
import UserPrescriptionPlaceOrder from "../UserProfile/UserPrescriptionPlaceOrder";
import UserNotes from "../UserProfile/UserNotes";
import UserShiftEdit from "../UserProfile/UserShiftEdit";
import UserBillingDetail from "../UserProfile/UserBillingDetail";
import UserPrescriptionAddress from "../UserProfile/UserPrescriptionAddress";
import UserThankyou from "../UserProfile/UserThankyou";
import UserVideocall from "../UserProfile/UserVideocall";
import UserWriteNow from "../UserProfile/UserWriteNow";
import UserSignUp from "../SignUp/UserSignUp";
import UserSignUpDetail from "../SignUp/UserSignUpDetail";
import PhysicianSignUp from "../SignUp/PhysicianSignUp";
import PhysicianSignUpDetail from "../SignUp/PhysicianSignUpDetail";
import PharmacySignUp from "../SignUp/PharmacySignUp";
import PhysicianAvailablity from "../SignUp/PhysicianAvailablity";
import PhysicianInfo from "../PhysicianProfile/PhysicianInfo";
import PhysicianPassword from "../PhysicianProfile/PhysicianPassword";
import PhysicianMyConsultations from "../PhysicianProfile/PhysicianMyConsultations";
import PhysicianConsultationDetail from "../PhysicianProfile/PhysicianConsultationDetail";
import PhysicianCurrentConsultations from "../PhysicianProfile/PhysicianCurrentConsultations";
import PhysicianCurrentConsultationsDetail from "../PhysicianProfile/PhysicianCurrentConsultationsDetail";
import PhysicianPastConsultations from "../PhysicianProfile/PhysicianPastConsultations";
import PhysicianPastConsultationsDetail from "../PhysicianProfile/PhysicianPastConsultationsDetail";
import PhysicianCurrentChat from "../PhysicianProfile/PhysicianCurrentChat";
import PhysicianPastChat from "../PhysicianProfile/PhysicianPastChat";
import PhysicianVideoCall from "../PhysicianProfile/PhysicianVideoCall";
import PhysicianPrescription from "../PhysicianProfile/PhysicianPrescription";
import PhysicianWritePrescription from "../PhysicianProfile/PhysicianWritePrescription";
import PhysicianNotes from "../PhysicianProfile/PhysicianNotes";
import PhysicianWriteNotes from "../PhysicianProfile/PhysicianWriteNotes";
import PharmacyInfo from "../PharmacyProfile/PharmacyInfo";
import PharmacyPassword from "../PharmacyProfile/PharmacyPassword";
import PrescriptionOrdersall from "../PharmacyProfile/PrescriptionOrdersall";
import PrescriptionOrdersPanding from "../PharmacyProfile/PrescriptionOrdersPanding";
import PrescriptionOrdersInProgress from "../PharmacyProfile/PrescriptionOrdersInProgress";
import PrescriptionOrdersComplete from "../PharmacyProfile/PrescriptionOrdersComplete";
import PrescriptionOrdersDetails from "../PharmacyProfile/PrescriptionOrdersDetails";
import SignIn from "../SignIn/SignIn";
import Otp from "../SignIn/Otp";
import CreateNewPassword from "../SignIn/CreateNewPassword";
import ForgetPassword from "../SignIn/ForgetPassword";
import LanFaqs from "../pages/LanFaqs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsofService from "../pages/TermsofService";
import Testimonials from "../pages/Testimonials";
import Services from "../pages/Services";
import BookAppointmentPayment from "../pages/BookAppointmentPayment";

// Define the PublicRoutes component
const PublicRoutes = () => {
	return (
		// Use BrowserRouter as the root component for routing
		<BrowserRouter>
			{/* Use Routes component to define your routes */}
			<Routes>
				{/* Define a route for the home  and multiple pages */}
				<Route path="/" element={<Home />} />
				<Route path="/aboutus" element={<AboutUs />} />
				<Route path="/howitwork" element={<HowItWork />} />
				<Route path="/contactus" element={<ContactUs />} />
				<Route path="/book-appointment" element={<BookAppointment />} />
				<Route
					path="/book-appointment-payment"
					element={<BookAppointmentPayment />}
				/>
				<Route path="/faqs" element={<LanFaqs />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/terms-of-service" element={<TermsofService />} />
				<Route path="/testimonials" element={<Testimonials />} />
				<Route path="/services" element={<Services />} />
				{/* sign up */}
				<Route path="/user-signup" element={<UserSignUp />} />
				<Route path="/user-signup-detail" element={<UserSignUpDetail />} />
				<Route path="/physician-signup" element={<PhysicianSignUp />} />
				<Route
					path="/physician-signup-detail"
					element={<PhysicianSignUpDetail />}
				/>
				<Route
					path="/physician-availablity"
					element={<PhysicianAvailablity />}
				/>
				<Route path="/pharmacy-signup" element={<PharmacySignUp />} />
				{/* Sign IN */}
				<Route path="/sign-in" element={<SignIn />} />
				<Route path="/otp" element={<Otp />} />
				<Route path="/forget-password" element={<ForgetPassword />} />
				<Route path="/create-new-password" element={<CreateNewPassword />} />
				{/* user profile */}
				<Route path="/personal-info" element={<UserPersonalInfo />} />
				<Route path="/change-password" element={<UserChangePassword />} />
				<Route path="/medical-report" element={<UserMyMedicalReport />} />
				<Route path="/my-order" element={<UserMyOrder />} />
				<Route path="/my-order-detail" element={<UserMyOrderDetail />} />
				<Route path="/my-consultations" element={<UserMyConsultations />} />
				<Route path="/user-shift-edit" element={<UserShiftEdit />} />
				<Route
					path="/consultation-detail"
					element={<UserConsultationDetail />}
				/>
				<Route path="/past-consultations" element={<UserPastConsultations />} />
				<Route
					path="/current-consultations"
					element={<UserCurrentConsultations />}
				/>
				<Route
					path="/current-consultations-detail"
					element={<UserCurrentConsultationsDetail />}
				/>
				<Route
					path="/past-consultations-Detail"
					element={<UserPastConsultationsDetail />}
				/>
				<Route path="/user-chat" element={<UserChat />} />
				<Route path="/user-prescription" element={<UserPrescription />} />
				<Route
					path="/user-prescription-placeorder"
					element={<UserPrescriptionPlaceOrder />}
				/>
				<Route path="/user-notes" element={<UserNotes />} />
				<Route path="/user-billing-detail" element={<UserBillingDetail />} />
				<Route
					path="/user-prescription-address"
					element={<UserPrescriptionAddress />}
				/>
				<Route path="/user-thankyou" element={<UserThankyou />} />
				<Route path="/user-videocall" element={<UserVideocall />} />
				<Route path="/user-write-now" element={<UserWriteNow />} />
				{/* Physician Profile */}
				<Route path="/physician-personal-info" element={<PhysicianInfo />} />
				<Route path="/physician-password" element={<PhysicianPassword />} />
				<Route
					path="/physician-myconsultations"
					element={<PhysicianMyConsultations />}
				/>
				<Route
					path="/physician-consultation-detail"
					element={<PhysicianConsultationDetail />}
				/>
				<Route
					path="/physician-current-consultations"
					element={<PhysicianCurrentConsultations />}
				/>
				<Route
					path="/physician-current-detail"
					element={<PhysicianCurrentConsultationsDetail />}
				/>
				<Route
					path="/physician-past-consultations"
					element={<PhysicianPastConsultations />}
				/>
				<Route
					path="/physician-Past-detail"
					element={<PhysicianPastConsultationsDetail />}
				/>
				<Route
					path="/physician-current-chat"
					element={<PhysicianCurrentChat />}
				/>
				<Route path="/physician-past-chat" element={<PhysicianPastChat />} />
				<Route path="/physician-video-call" element={<PhysicianVideoCall />} />
				<Route
					path="/physician-prescription"
					element={<PhysicianPrescription />}
				/>
				<Route
					path="/write-prescription"
					element={<PhysicianWritePrescription />}
				/>
				<Route path="/physician-notes" element={<PhysicianNotes />} />
				<Route
					path="/physician-write-notes"
					element={<PhysicianWriteNotes />}
				/>
				{/* Pharmacy Profile */}
				<Route path="/pharmacy-info" element={<PharmacyInfo />} />
				<Route
					path="/pharmacy-change-password"
					element={<PharmacyPassword />}
				/>
				<Route
					path="/prescription-orders-all"
					element={<PrescriptionOrdersall />}
				/>
				<Route
					path="/prescription-orders-Panding"
					element={<PrescriptionOrdersPanding />}
				/>
				<Route
					path="/prescription-orders-inprogress"
					element={<PrescriptionOrdersInProgress />}
				/>
				<Route
					path="/prescription-orders-complete"
					element={<PrescriptionOrdersComplete />}
				/>
				<Route
					path="/prescription-orders-details"
					element={<PrescriptionOrdersDetails />}
				/>
			</Routes>
		</BrowserRouter>
	);
};

// Export the PublicRoutes component
export default PublicRoutes;
